import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = ['progressBar'];

  connect() {
    this.setDaysElapsedPosition();
    window.addEventListener('resize', this.setDaysElapsedPosition.bind(this));
  }

  setDaysElapsedPosition() {
    document.documentElement.style.setProperty(
      '--progress-bar-width',
      this.progressBarTarget.offsetWidth + 'px'
    );
  }
}
